<template>
  <!-- 人员及资产管理 -> 设置借出 author: zhangxiaofeng -->
  <div class="config-lent--main">
    <!-- 有可配置资产 或 该用户已经配置过资产 -->
    <w-dialog :show="model.hasAsset"
              confirm
              show-close
              class="has-asset-model"
              :box-style="{width: '900px'}"
              :bodyStyle="{ padding: '20px 24px' }"
              title="设置借出"
              @close="cancel('hasAsset')">
      <div>
        <div class="suffix-reg-tip">
          <p>说明：分配过权限的产品包或产品，可借出使用！</p>
        </div>
        <div class="detail">
          分配员工：{{configItem.account}}
          <div class="lock-list">
            <w-select v-model="usbKey"
                      :key="optionsReady"
                      style="width: 240px"
                      :disabled="options.length === 0 || configItem.borrowNum"
                      placeholder="请选择加密锁">
              <w-option
                v-for="item in options"
                style="width: 240px"
                :key="item.value"
                :label="item.label"
                :disabled="item.disabled"
                :value="item.value">
              </w-option>
            </w-select>
          </div>
        </div>
        <asset-product-list v-if="assetAll.length"
                            :config-item="configItem"
                            @listReady="listReadyHandle"
                            @checkedChange="checkedChangeHandle"
                            :asset-list="assetAll"
                            :pop-type="popType">
        </asset-product-list>
        <p v-if="errorType" class="error-message">{{errorTips[errorType]}}</p>
      </div>
      <template slot="footer">
        <w-button type="primary" @click="submit('hasAsset')" :disabled="saving">确定</w-button>
        <w-button type="minor" @click="cancel('hasAsset')">取消</w-button>
      </template>
    </w-dialog>
  </div>
</template>
<style lang="less" type="text/less">
  @import "./index";
</style>
<script>
import configAssetMixins from '@/assets/mixins/config-asset.js'
import AssetProductList from './AssetProductList'
import manageService from 'service/manage.js'
export default {
  name: 'ConfigLent',
  mixins: [configAssetMixins],
  data () {
    return {
      // 加密锁列表
      options: [],
      optionsReady: 0,
      popType: 'Lent',
      usbKey: '' // 当前选择的加密锁
    }
  },
  methods: {
    // 1. 显示 配置产品弹窗
    showConfigPop () {
      this.model.hasAsset = true
      if (this.assetAll.length) {
        // 有已配置资产 或 有可配置资产
      } else {
        // 无可用资产
      }
    },
    // 2. 获取企业现有可借出锁
    getUsbKey () {
      manageService.getUsbKey().then((data) => {
        const list = data.data || []
        if (+data.code === 200) {
          const options = []
          list.forEach((item) => {
            const tempItem = {}
            tempItem.value = item.assetNum
            tempItem.label = item.assetNum
            tempItem.disabled = item.borrowedFlag
            options.push(tempItem)
          })
          this.options = options
          this.usbKey = this.configItem.borrowNum || ''
          this.optionsReady++
        }
      }).catch((e) => {
        console.log(e)
      })
    },
    // 3.1 弹窗 确定
    submit (type) {
      if (this.saving) return
      if (this.usbKey === '') {
        this.showErrorMessage(4001)
        return
      }
      // 未选择 新的资产时 借出原已借出资产
      if (!this.checkedAssetChange) {
        for (const key in this.checkedBefore) {
          this.addAsset.push(key)
        }
      }
      // if (!this.addAsset.length) {
      //   this.showErrorMessage(4002)
      //   return
      // }
      if (this.addAsset.length) {
        this.saving = true
        manageService.assetBorrow(this.configItem.gldUserId, this.addAsset.join(','), this.usbKey).then((data) => {
          if (+data.code === 200) {
            manageService.addRelationLog({
              area: this.userInStore.area,
              detail: `${this.configItem.account}-${this.addAsset.join(',')}`,
              operateType: 'ASSET_LENDING',
              relType: '',
              showState: 1
            })
            this.model[type] = false
            this.$emit('submit', this.popType)
          } else {
            this.showErrorMessage(data.code)
          }
          this.saving = false
        }).catch((e) => {
          console.log(e)
          this.showErrorMessage(340024)
          this.saving = false
        })
      } else {
        this.cancel(type)
      }
    }
  },
  components: {
    AssetProductList
  }
}
</script>
